import { render, staticRenderFns } from "./BGAssetLoader.vue?vue&type=template&id=5d92aea8&scoped=true&"
import script from "./BGAssetLoader.vue?vue&type=script&lang=js&"
export * from "./BGAssetLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d92aea8",
  null
  
)

export default component.exports